import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import { IGroupedDevice } from '../../../shared';

@Component({
  selector: 'awair-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss']
})

export class GroupListComponent implements OnInit {

  groupList: IGroupedDevice[];
  unassigned: IGroupedDevice;

  private _groupedDeviceList: IGroupedDevice[];
  get groupedDeviceList() {
    return this._groupedDeviceList;
  }
  @Input()
  set groupedDeviceList(value: IGroupedDevice[]) {
    if (value != null) {
      this._groupedDeviceList = [...value];
      this.unassigned = this._groupedDeviceList.pop();
      this.groupList = this._groupedDeviceList;
    }
  }
  @Input() selectedId: string;
  @Output() selectGroupId: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  clickGroup(groupId: string): void {
    this.selectedId = groupId;
    this.selectGroupId.emit(groupId);
  }
}
